import React from 'react';
import { styled, MenuItem as MuiMenuItem } from '@mui/material';
import clsx from 'clsx';
import { optionClasses, getOptionStyle } from './style';
import { IconChecked } from '../../internal/icons';
import OverflowTooltip from '../../Shared/OverflowTooltip';
const StyledOption = styled(MuiMenuItem, {
    shouldForwardProp: (key) => key !== 'multiline',
})((props) => {
    const { theme, size = 'medium', multiline } = props;
    return getOptionStyle(theme, { size, multiline });
});
const Option = React.forwardRef((props, ref) => {
    const { selected, multiline } = props;
    return (React.createElement(StyledOption, { ...props, ref: ref, classes: {
            root: optionClasses.root,
            disabled: optionClasses.disabled,
            selected: optionClasses.selected,
        } },
        multiline ? (React.createElement("span", { className: optionClasses.text }, props.children)) : (React.createElement(OverflowTooltip, { className: optionClasses.text }, props.children)),
        selected ? React.createElement(IconChecked, { className: optionClasses.icon }) : React.createElement("span", { className: clsx(optionClasses.icon, optionClasses.iconPlaceholder) })));
});
export default Option;
